var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('Container',{ref:"container"},[_c('List',_vm._l((_vm.cardList),function(item){return _c('DistributorCard',{key:item.id,attrs:{"data":item}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }